import { Component, Input, ChangeDetectionStrategy, inject, signal, viewChild } from '@angular/core';
import { take } from 'rxjs';
import { TourService } from '../../../tour-planning/shared/services/tour/tour.service';
import { Tour } from '../../../tour-planning/shared/entities/tour';
import { TourDetailsOverlayComponent } from '../tour-details-overlay/tour-details-overlay.component';

export interface AssignmentData {
  id: string;
  displayName: string;
  assignmentType: string;
}

@Component({
  selector: 'nx-assignment-display',
  templateUrl: './assignment-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignmentDisplayComponent {
  private readonly tourService = inject(TourService);
  
  @Input() assignee: AssignmentData | null = null;
  
  readonly tourOverlay = viewChild<TourDetailsOverlayComponent>('tourOverlay');
  readonly tourDetails = signal<Tour | undefined>(undefined);
  readonly isLoadingTourDetails = signal(false);

  onTourHover(event: MouseEvent, id: string): void {
    const overlay = this.tourOverlay();
    if (overlay) {
      overlay.show(event);
      this.loadTourDetails(id);
    }
  }

  onTourLeave(): void {
    const overlay = this.tourOverlay();
    if (overlay) {
      overlay.hide();
    }
  }
  
  private loadTourDetails(tourId: string): void {
    this.isLoadingTourDetails.set(true);
    this.tourService.getTourOverlayDetails(tourId)
      .pipe(take(1))
      .subscribe({
        next: (tour) => {
          this.tourDetails.set(tour);
          this.isLoadingTourDetails.set(false);
        },
        error: () => {
          this.isLoadingTourDetails.set(false);
        }
      });
  }
}
